import { useParams, useSearchParams } from "react-router-dom";

import { gridTemplate } from "../../config/defines";
import Layout from "../../components/Layout";
import LiveCard from "../../components/LiveCard";

export default function Live() {
	const { url = "" } = useParams();
	const [searchParams] = useSearchParams();

	const v = searchParams.get("v");
	const urlParam = v ? v : url;

	const livesUrls = atob(urlParam)
		.split(";")
		.filter((url) => url.length > 0);

	const livesCount = livesUrls.length ?? 0;
	const livesGrid = gridTemplate(livesCount);

	return (
		<Layout authentication={false}>
			<div
				className="position-absolute"
				style={{
					inset: 0,
					height: "100%",
					backgroundImage: `url(${process.env.PUBLIC_URL}/login_background.webp)`,
					backgroundSize: "cover",
					zIndex: -1,
				}}
			/>

			<div className="d-flex p-0" style={{ height: "calc(100dvh - 56px)", marginTop: 56 }}>
				<div className="flex-fill w-100 p-2" style={{ display: "grid", gridTemplateColumns: livesGrid.gridTemplateColumns, gap: 5 }}>
					{livesUrls.map((liveUrl, index) => {
						return (
							<div key={index} style={{ gridColumn: livesGrid.gridColumns[index], gridRow: livesGrid.gridRows ? livesGrid.gridRows[index] : "auto" }}>
								<LiveCard liveUrl={liveUrl} onClick={() => {}} />
							</div>
						);
					})}
				</div>
			</div>
		</Layout>
	);
}
